module.exports = __webpack_public_path__ + "img/ex-tasks_xl.14ae6b7e.png";